import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './tabs.css';

const TabPanel = ({ content, active }) =>
  <div className={`${styles.tabPanel} ${active ? styles.active : ''}`}>{content}</div>;
TabPanel.propTypes = {
  content: PropTypes.node,
  active: PropTypes.bool,
};

export default TabPanel;
